import { Mascot, MascotId, MASCOT_CATALOG, DEFAULT_MASCOT_SRC } from "../constants/mascotCatalog";
import { useMascotActions, useSelectedMascotId } from "../stores";

interface UseMascotReturn {
    currentMascot: Mascot | null;           //objeto completo
    currentMascotSrc: string;               //mascota elegida o null
    isCustomSelected: boolean;              //true si tiene mascota elegida
    selectMascot: (id: MascotId) => void;   //funcion para seleccionar
    catalog: readonly Mascot[];             //catálogo completo
};

export const useMascot = (): UseMascotReturn => {
    const selectedId = useSelectedMascotId();
    const selectMascot = useMascotActions();
    //si selectedId existe, busca en el catálogo y devuelve el objeto completo, si no, devuelve null
    const currentMascot = selectedId
        ? MASCOT_CATALOG.find((mascot) => mascot.id === selectedId) ?? null
        : null
    //si currentMascot es null, devuelve undefined, y el ?? lo reemplaza con el default.
    const currentMascotSrc = currentMascot?.src ?? DEFAULT_MASCOT_SRC;
    const isCustomSelected = selectedId !== null;

    return {
        currentMascot,
        currentMascotSrc,
        isCustomSelected,
        selectMascot,
        catalog: MASCOT_CATALOG,
    };
};